import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { InputBase, alpha, styled, useTheme } from "@mui/material";

import { tokens } from "@/components/Application/theme";

const StyledInputBase = styled(InputBase)(({ theme }) => ({
	color: "inherit",
	width: "200px",
	padding: theme.spacing(0, 1, 0, 1),
	border: "1px solid #ccc",
	borderRadius: theme.shape.borderRadius,
	backgroundColor: "fee",
	transition: "width 0.3s ease-in-out",
	"&.Mui-focused": {
		width: "250px",
	},
}));

const Search = styled("div")(({ theme }) => ({
	position: "relative",
	display: "inline-flex",
    justifySelf: "end",
	justifyContent: "end",
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(theme.palette.common.white, 0.15),
	marginLeft: 0,
	width: "80%",
	[theme.breakpoints.down("sm")]: {
		marginLeft: theme.spacing(1),
		width: "auto",
	},
}));

type Props = {
	searchParams: string;
	setSearchParams: (searchParams: string) => void;
};

const SearchBar = ({ searchParams, setSearchParams }: Props) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	return (
		<Search>
			<StyledInputBase
				startAdornment={<SearchIcon />}
				endAdornment={
					searchParams && (
						<CloseIcon
                            fontSize="small"
							sx={{ color: colors.grey["500"], cursor: "pointer" }}
							onClick={() => setSearchParams("")}
						/>
					)
				}
				placeholder="Search…"
				inputProps={{ "aria-label": "search" }}
				value={searchParams}
				onChange={(e) => setSearchParams(e.target.value)}
			/>
		</Search>
	);
};

export default SearchBar;
